import {Btn, Icon} from '../../../../ui-toolkit';
import {Table} from '../../../../ui-toolkit/indexExportV2';
import React from 'react';

export function SkeletonRow() {
    return (
        <Table.Row shimmer={true}>
            <Table.Data colSpan={999}>
                <Btn
                    color="default"
                    link="true"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}>
                    <Icon name="ZoomIn" />
                </Btn>
            </Table.Data>
        </Table.Row>
    );
}
